import React, {FC, useEffect, useState} from 'react'
import {getBranchStatistics} from './Api'
import {IBranchStatisticsModel} from './DashboardModel'

const BranchStatisticsTable: FC = () => {
  const [data, setData] = useState<IBranchStatisticsModel[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    getBranchStatistics()
      .then((res: any) => {
        const payload = res.data?.payload ?? res.payload ?? []
        setData(Array.isArray(payload) ? payload : [])
      })
      .catch((err) => console.error('Şube istatistikleri yüklenemedi:', err))
      .finally(() => setLoading(false))
  }, [])

  const totals = data.reduce(
    (acc, row) => ({
      fleet: acc.fleet + row.fleet,
      availableCar: acc.availableCar + row.availableCar,
      rented: acc.rented + row.rented,
      inMaintenance: acc.inMaintenance + row.inMaintenance,
      returnsToday: acc.returnsToday + row.returnsToday,
      departures: acc.departures + row.departures,
      departuresToday: acc.departuresToday + row.departuresToday,
      outgoingReservations: acc.outgoingReservations + row.outgoingReservations,
      returns: acc.returns + row.returns,
      baf: acc.baf + row.baf,
      forSale: acc.forSale + row.forSale,
    }),
    {
      fleet: 0,
      availableCar: 0,
      rented: 0,
      inMaintenance: 0,
      returnsToday: 0,
      departures: 0,
      departuresToday: 0,
      outgoingReservations: 0,
      returns: 0,
      baf: 0,
      forSale: 0,
    }
  )

  const totalFleet = totals.fleet || 1
  const totalOccupancy = ((totals.rented / totalFleet) * 100).toFixed(2)

  const columns = [
    {header: 'Şubeler', key: 'branchName'},
    {header: 'Filo', key: 'fleet'},
    {header: 'Boş Araç', key: 'availableCar'},
    {header: 'Kirada', key: 'rented'},
    {header: 'Bakımda', key: 'inMaintenance'},
    {header: 'Doluluk', key: 'occupancyRate'},
    {header: 'Dönecekler', key: 'returnsToday'},
    {header: 'Çıkışlar', key: 'departures'},
    {header: 'Çıkacaklar', key: 'departuresToday'},
    {header: 'Giden Rez.', key: 'outgoingReservations'},
    {header: 'Dönüşler', key: 'returns'},
    {header: 'Baf', key: 'baf'},
    {header: 'Satılık', key: 'forSale'},
  ]

  return (
    <div className='card'>
      <div className='card-body p-0'>
        <div className='table-responsive'>
          <table className='table table-row-bordered table-row-gray-300 align-middle gs-4 gy-3 mb-0'>
            <thead>
              <tr
                style={{
                  background: 'linear-gradient(135deg, #1e1e2d 0%, #2d2d44 100%)',
                }}
              >
                {columns.map((col) => (
                  <th
                    key={col.key}
                    className={`text-white fw-bold fs-7 ${col.key === 'branchName' ? 'text-start ps-6' : 'text-center'}`}
                    style={{whiteSpace: 'nowrap'}}
                  >
                    {col.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={columns.length} className='text-center py-10'>
                    <span className='spinner-border spinner-border-sm me-2' />
                    Yükleniyor...
                  </td>
                </tr>
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} className='text-center py-10 text-muted'>
                    Veri bulunamadı
                  </td>
                </tr>
              ) : (
                <>
                  {data.map((row, idx) => {
                    const occupancy = row.fleet > 0 ? ((row.rented / row.fleet) * 100).toFixed(2) : '0.00'
                    return (
                      <tr key={idx} className={idx % 2 === 0 ? 'bg-light' : ''}>
                        <td className='text-start ps-6 fw-semibold text-dark'>{row.branchName}</td>
                        <td className='text-center text-primary fw-bold'>{row.fleet}</td>
                        <td className='text-center'>{row.availableCar}</td>
                        <td className='text-center text-primary fw-bold'>{row.rented}</td>
                        <td className='text-center'>{row.inMaintenance}</td>
                        <td className='text-center'>%{occupancy}</td>
                        <td className='text-center'>{row.returnsToday}</td>
                        <td className='text-center'>{row.departures}</td>
                        <td className='text-center'>{row.departuresToday}</td>
                        <td className='text-center'>{row.outgoingReservations}</td>
                        <td className='text-center text-primary fw-bold'>{row.returns}</td>
                        <td className='text-center'>{row.baf}</td>
                        <td className='text-center'>{row.forSale}</td>
                      </tr>
                    )
                  })}
                  <tr style={{background: '#f1f1f4'}}>
                    <td className='text-center fw-bolder text-dark'>Toplam</td>
                    <td className='text-center fw-bolder text-primary'>{totals.fleet}</td>
                    <td className='text-center fw-bolder'>{totals.availableCar}</td>
                    <td className='text-center fw-bolder text-primary'>{totals.rented}</td>
                    <td className='text-center fw-bolder'>{totals.inMaintenance}</td>
                    <td className='text-center fw-bolder'>%{totalOccupancy}</td>
                    <td className='text-center fw-bolder'>{totals.returnsToday}</td>
                    <td className='text-center fw-bolder'>{totals.departures}</td>
                    <td className='text-center fw-bolder'>{totals.departuresToday}</td>
                    <td className='text-center fw-bolder'>{totals.outgoingReservations}</td>
                    <td className='text-center fw-bolder text-primary'>{totals.returns}</td>
                    <td className='text-center fw-bolder'>{totals.baf}</td>
                    <td className='text-center fw-bolder'>{totals.forSale}</td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default BranchStatisticsTable
